export enum DashboardEmbedType {
    QUESTION = "question",
    DASHBOARD = "dashboard",
}

export const COMMON_METABASE_CONFIG = {
    embeds: {
        questions: {},
        dashboards: {
            oneVerifyMain: 136, // ID from metabase
        },
    },
}
